import type { App } from "vue";
import { autoAnimatePlugin } from "@formkit/auto-animate/vue";

export default {
	install: (app: App) => {
		app.use(autoAnimatePlugin);
	},
};
